module.exports = __webpack_public_path__ + "html5.7ee29b210fca86da8b10.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/html5.png
// module id = ../../../../../src/assets/images/html5.png
// module chunks = main